var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: _vm.PERMISSIONS.VIEW_PORTFOLIO,
          expression: "PERMISSIONS.VIEW_PORTFOLIO",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c("portfolio-widget-row", { attrs: { fetch: true } }),
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
        on: { "on-load-success": this.vueFormatterInit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }